import type { ZeytalCLIPureConfig } from "@zeytal/kit";
import type { FigmaRestApi, ZeytalTokens } from "@zeytal/types";

import { paintToSelectedFormat } from "../../../utils/colors.ts";

export const gridMaker = (
  stylesFormatsConfig: ZeytalCLIPureConfig["styles"]["formats"],
  gridValues: FigmaRestApi.LayoutGrid[],
) => {
  const value: ZeytalTokens.GridStyleValue = gridValues
    .filter(({ visible }) => visible)
    .map(
      ({
        pattern,
        sectionSize,
        color,
        alignment,
        gutterSize,
        offset,
        count,
      }) => {
        const gridStyleValue: ZeytalTokens.GridStyle = {
          pattern: pattern.toLowerCase() as Lowercase<
            FigmaRestApi.LayoutGrid["pattern"]
          >,
          sectionSize,
          alignment: alignment.toLowerCase() as Lowercase<
            FigmaRestApi.LayoutGrid["alignment"]
          >,
          gutterSize,
          offset,
          count,
        };

        if (stylesFormatsConfig.grids.extractColors) {
          gridStyleValue.color = paintToSelectedFormat(
            stylesFormatsConfig.colors,
            color,
          );
        }

        return gridStyleValue;
      },
    );

  return value;
};
